/*
 * <faith-motion>: lazy video tiles. A video's source is attached only when the tile nears the viewport,
 * it plays only while at least 35% visible, and pauses otherwise. Reduced motion: nothing loads, the
 * poster stays.
 */
(() => {
  'use strict';
  if (customElements.get('faith-motion')) return;

  class FaithMotion extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('video[data-src]')];
      if (!this.videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.loader = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const video = entry.target;
          video.src = video.dataset.src;
          video.preload = 'metadata';
          this.loader.unobserve(video);
        });
      }, { rootMargin: '300px 0px' });

      this.player = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && video.getAttribute('src')) video.play().catch(() => { /* autoplay blocked: poster stays */ });
          else video.pause();
        });
      }, { threshold: 0.35 });

      this.videos.forEach((video) => { this.loader.observe(video); this.player.observe(video); });
    }

    disconnectedCallback() {
      this.loader?.disconnect();
      this.player?.disconnect();
    }
  }

  customElements.define('faith-motion', FaithMotion);
})();
